import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Flex } from "@edreamsodigeo/prisma-design-system";
import { CascadeComponent, CascadeContainer } from "../../components/common/components";
import LoginAndFindByBookingReferenceContainer from "../../components/LoginAndFindByBookingReferenceContainer/LoginAndFindByBookingReferenceContainer";
import ManageBookingsBanner from "../../components/ManageBookingsBanner";
import SupportAreaValueProposition from "../../components/SupportAreaValueProposition/SupportAreaValueProposition";
import MyTripsLoginTabs from "./components/MyTripsLoginTabs";
const MyTripsLoginMobileSupportAreaContainer = ({
  userAuthentication
}) => {
  const [activeTab, setActiveTab] = useState(1);
  const cascadeComponents = [/*#__PURE__*/React.createElement(CascadeComponent, {
    key: "0",
    withBorderTop: false
  }, /*#__PURE__*/React.createElement(SupportAreaValueProposition, null)), /*#__PURE__*/React.createElement(CascadeComponent, {
    key: "1",
    color: "neutral.0",
    position: "relative"
  }, /*#__PURE__*/React.createElement(Box, {
    p: "base",
    position: "relative"
  }, /*#__PURE__*/React.createElement(MyTripsLoginTabs, {
    UserAuthentication: userAuthentication,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  })))];
  return /*#__PURE__*/React.createElement(CascadeContainer, {
    cascadeComponents: cascadeComponents
  });
};
const MyTripsLoginMobileContainer = ({
  hasWelcomeSupportAreaBanner,
  userAuthentication,
  incentivizeUserAuthentication
}) => hasWelcomeSupportAreaBanner ? /*#__PURE__*/React.createElement(MyTripsLoginMobileSupportAreaContainer, {
  userAuthentication: userAuthentication
}) : /*#__PURE__*/React.createElement(Flex, {
  flexDirection: "column",
  backgroundColor: "primary.10"
}, /*#__PURE__*/React.createElement(ManageBookingsBanner, null), /*#__PURE__*/React.createElement(Box, {
  backgroundColor: "neutral.0",
  borderTopLeftRadius: "big",
  borderTopRightRadius: "big"
}, /*#__PURE__*/React.createElement(LoginAndFindByBookingReferenceContainer, {
  incentivizeUserAuthentication: incentivizeUserAuthentication,
  px: "big"
})));
MyTripsLoginMobileContainer.propTypes = {
  hasWelcomeSupportAreaBanner: PropTypes.bool,
  userAuthentication: PropTypes.element,
  incentivizeUserAuthentication: PropTypes.element
};
export default MyTripsLoginMobileContainer;